<div class="row d" >
  <div class="col-lg-7">
    <div class="d-md-flex">
      <div class="m-b-10 m-r-20">
        <nz-input-group [nzPrefix]="prefixTemplate" [nzSuffix]="suffixTemplate">
          <input
            nz-input
            placeholder="Search"
            (keyup)="onKeyUp(searchBox.value)"
            #searchBox
            [(ngModel)]="searchTerm"
            ng-model-options="{ debounce: 1000 }"
            nzSize="small"
          />
        </nz-input-group>
        <ng-template #suffixTemplate>
          <a nz-icon class="opacity-05" (click)="resetSearch()">
            <i nz-icon nzType="close" class="opacity-05"></i>
          </a>
        </ng-template>
        <ng-template #prefixTemplate>
          <i nz-icon nzType="search" class="opacity-05"></i>
        </ng-template>
      </div>
    </div>
  </div>
  <div class="col-lg-5">
    <div class="d-md-flex justify-content-end">
      <div class="m-b-10 m-r-10"></div>
      <!-- <button
        nz-button
        nzType="default"
        nz-popover
        nzPopoverPlacement="bottomRight"
        nzPopoverTrigger="click"
        class="btn-fill"
      >
        <span>
          <i class="fa fa-plus button-plus-icon" aria-hidden="true"></i></span
        >&nbsp;NEW
      </button> -->
    </div>
  </div>
</div>

<div class="row" [@wipeOutRight]>
  <div nz-col>
    <div style="max-height: 400px; overflow-y:auto">
      <nz-table
        #kbListTable
        [nzData]="knowledgeBaseData"
        class="no-border-last"
        [nzPageSize]="20"
        nzSize="small"
      >
        <thead>
          <tr>
            <th style="width: 1vw">
              <label
                nz-checkbox
                [(nzChecked)]="allChecked"
                (nzCheckedChange)="checkAll($event)"
              ></label>
            </th>
            <ng-container *ngFor="let column of listOfColumns">
              <th
                *ngIf="column.name !== ''"
                [nzSortOrder]="column.sortOrder"
                [nzSortFn]="column.sortFn"
                [nzSortDirections]="column.sortDirections"
                [nzFilterMultiple]="column.filterMultiple"
                [nzWidth]="column.colWidth"
              >
                {{ column.name }}
              </th>
              <th *ngIf="column.name === ''">{{ column.name }}</th>
            </ng-container>
            <!-- <th nzShowSort nzSortKey="group">Knowledge Base</th>
            <th nzShowSort nzSortKey="tags">Tags</th>
            <th></th> -->
          </tr>
        </thead>
        <tbody>
          <ng-template ngFor let-item [ngForOf]="kbListTable.data">
            <tr>
              <td
                nzShowCheckbox
                [(nzChecked)]="item.checked"
                (nzCheckedChange)="onCheckboxChange()"
              ></td>
              <td>{{ item.question_text }}</td>
              <td>
                <ng-container *ngIf="item.tag && item.tag.length > 0">
                  <ng-container
                    *ngIf="item.tag.length <= 2; else moreTags"
                  >
                    <nz-tag
                      *ngFor="let tag of item.tag.slice(0, 2)"
                      [nzMode]="default"
                      [nzColor]="'#ededed'"
                    >
                      {{ tag.tag_name }}
                    </nz-tag>
                  </ng-container>
                  <ng-template #moreTags>
                    <span *ngFor="let tag of item.tag.slice(0, 2)">
                      <nz-tag [nzMode]="default" [nzColor]="'#ededed'">{{
                        tag.tag_name
                      }}</nz-tag>
                    </span>

                    <span
                      nz-popover
                      [nzPopoverContent]="moreContents"
                      nzPopoverPlacement="bottom"
                      (mouseenter)="updateMoreTagsContent(item.tag)"
                      (mouseleave)="resetMoreTagsContent()"
                    >
                      <nz-tag [nzMode]="default" [nzColor]="'#ededed'"
                        >+{{ item.tag.length - 2 }} more</nz-tag
                      >
                    </span>

                    <ng-template #moreContents>
                      <span *ngFor="let tag of moreTagsContent">
                        <nz-tag
                          [nzMode]="default"
                          [nzColor]="'#ededed'"
                          >{{ tag }}</nz-tag
                        >
                      </span>
                    </ng-template>
                  </ng-template>
                </ng-container>
              </td>
              <!-- <td>
                <nz-tag
                  *ngFor="let tag of item.tag; let i = index"
                  [nzMode]="default"
                  [nzColor]="'#ededed'"
                >
                  {{ tag.tag_name }}
                </nz-tag>
              </td> -->
            </tr>
          </ng-template>
        </tbody>
      </nz-table>
    </div>
  </div>
</div>
